import { render, staticRenderFns } from "./success-section.vue?vue&type=template&id=84e9e972&"
import script from "./success-section.vue?vue&type=script&lang=js&"
export * from "./success-section.vue?vue&type=script&lang=js&"
import style0 from "./success-section.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports